import _jsx from "@babel/runtime/helpers/jsx";

var _Wrapper;

import React, { memo } from 'react';
import Banner from 'components/Banner';
import Wrapper from './styles';
var PageSidebar = /*#__PURE__*/memo(function () {
  return _Wrapper || (_Wrapper = /*#__PURE__*/_jsx(Wrapper, {
    id: "mc-sidebar"
  }, void 0, /*#__PURE__*/_jsx(Banner, {
    id: "hp-react-banner-premium",
    slot: "bn-slot-premium"
  }), /*#__PURE__*/_jsx(Banner, {
    id: "hp-react-banner-sticky",
    slot: "bn-slot-sticky",
    isSticky: true
  })));
});
export default PageSidebar;